import {
  Table,
  Thead,
  Tr,
  Th,
  Tbody,
  Td,
  Tfoot,
  useDisclosure,
} from '@chakra-ui/react';
import React, { useState } from 'react';

import { GetApiKeys_viewer_apiKeys } from '@/backend/graphql/apikeys/__generated__/GetApiKeys';
import useGetApiKeys from '@/backend/graphql/apikeys/useGetApiKeys';
import CreateNewApiKeyModal from '@/components/apikeys/CreateNewApiKeyModal';
import DeactivateApiKeyModal from '@/components/apikeys/DeactivateApiKeyModal';
import Button from '@/components/Button';

export default function ApiKeysPage() {
  const {
    isOpen: isDeactivateModalOpen,
    onOpen: onDeactivateModalOpen,
    onClose: onDeactivateModalClose,
  } = useDisclosure();
  const {
    isOpen: isCreateNewApiKeyModalOpen,
    onOpen: onCreateNewApiKeyModalOpen,
    onClose: onCreateNewApiKeyModalClose,
  } = useDisclosure();
  const [
    apiKeySelected,
    setApiKeySelected,
  ] = useState<GetApiKeys_viewer_apiKeys>();

  const { apiKeys } = useGetApiKeys();

  return (
    <div style={{ minHeight: '43vh' }}>
      <div className="text-2xl text-center my-10">Api Key Manager</div>
      <Table variant="simple">
        <Thead>
          <Tr>
            <Th>Name</Th>
            <Th>Status</Th>
            <Th>Deactivate</Th>
          </Tr>
        </Thead>
        <Tbody>
          {apiKeys.length ? (
            apiKeys.map((apiKey, index) => (
              <Tr key={index}>
                <Td>{apiKey.name}</Td>
                <Td>
                  {apiKey.deactivatedAt
                    ? `Deactivated at ${apiKey.deactivatedAt}`
                    : 'Active'}
                </Td>

                <Td>
                  {apiKey.deactivatedAt ? (
                    apiKey.deactivatedAt
                  ) : (
                    <Button
                      onClick={() => {
                        setApiKeySelected(apiKey);
                        onDeactivateModalOpen();
                      }}
                      variant="solid">
                      deactivate
                    </Button>
                  )}
                </Td>
              </Tr>
            ))
          ) : (
            <Tr>
              <Td colSpan={3}>No Api Keys</Td>
            </Tr>
          )}
        </Tbody>
        <Tfoot>
          <Tr>
            <Th>
              <Button onClick={onCreateNewApiKeyModalOpen} variant="solid">
                Add New
              </Button>
            </Th>
          </Tr>
        </Tfoot>
      </Table>
      <CreateNewApiKeyModal
        isOpen={isCreateNewApiKeyModalOpen}
        onClose={onCreateNewApiKeyModalClose}
      />
      <DeactivateApiKeyModal
        isOpen={isDeactivateModalOpen}
        onClose={onDeactivateModalClose}
        apiKeySelected={apiKeySelected}
      />
    </div>
  );
}
